(() => {
  const root = document.querySelector('.bf-product');
  if (!root) return;
  const form = root.querySelector('#bf-form');
  const variants = JSON.parse(document.getElementById('bf-variants').textContent);
  const config = JSON.parse(document.getElementById('bf-purchase-config').textContent);
  const status = document.getElementById('bf-status');
  const submit = form.querySelector('[type=submit]');
  const money = amount => new Intl.NumberFormat(config.locale, { style: 'currency', currency: config.currency }).format(amount / 100).replace('￥', '¥');
  const current = () => variants.find(variant => String(variant.id) === form.elements.id.value);
  const selectedPlan = () => String(new FormData(form).get('selling_plan') || '');
  const allocationFor = (variant, planId = selectedPlan()) => (variant?.plans || []).find(plan => String(plan.id) === planId);
  root.querySelectorAll('.bf-thumb').forEach(button => button.addEventListener('click', () => {
    const image = document.getElementById('bf-main-image');
    image.removeAttribute("srcset");
    image.src = button.dataset.image;
    image.alt = button.querySelector('img').alt;
    root.querySelectorAll('.bf-thumb').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
  }));
  function update(writeUrl = true) {
    const variant = current();
    if (!variant) return;
    const planId = selectedPlan();
    const allocation = allocationFor(variant, planId);
    submit.disabled = !variant.available || Boolean(planId && !allocation) || form.getAttribute('aria-busy') === 'true';
    document.getElementById('bf-sticky-price').textContent = money(allocation ? allocation.price : variant.price);
    const note = document.getElementById('bf-purchase-note');
    if (note) note.textContent = allocation ? allocation.name + ' · ' + money(allocation.price) : note.dataset.once;
    if (writeUrl) {
      const url = new URL(location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState(null, '', url);
    }
    status.textContent = '';
  }
  root.addEventListener('change', event => {
    if (event.target.name === 'bf_variant') {
      form.elements.id.value = event.target.value;
      form.elements.id.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    requestAnimationFrame(() => update());
  });
  root.addEventListener('click', event => {
    if (event.target.closest('kaching-bundles-block')) requestAnimationFrame(() => update());
  });
  form.addEventListener('submit', async event => {
    event.preventDefault();
    const variant = current();
    if (!variant?.available || submit.disabled) return;
    const planId = selectedPlan();
    const allocation = allocationFor(variant, planId);
    if (planId && !allocation) return;
    submit.disabled = true;
    form.setAttribute('aria-busy', 'true');
    status.textContent = 'カートに追加しています…';
    try {
      const properties = {};
      for (const [name, value] of new FormData(form)) {
        const match = name.match(/^properties\[(.+)\]$/);
        if (match && value) properties[match[1]] = value;
      }
      const line = { id: variant.id, quantity: 1, properties };
      if (allocation) line.selling_plan = allocation.id;
      const response = await fetch(config.addUrl, {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [line] })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || '追加できませんでした。');
      location.href = config.checkoutUrl;
    } catch (error) {
      status.textContent = error.message || '通信に失敗しました。もう一度お試しください。';
      submit.disabled = !variant.available;
      form.removeAttribute('aria-busy');
    }
  });
  const sticky = document.getElementById('bf-sticky');
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0)).observe(form);
  }
  // Kaching inserts the default selling plan after this script has initialized.
  // Keep the purchase summary aligned without waiting for a customer interaction.
  let observedSelection = '';
  new MutationObserver(() => {
    const selection = form.elements.id.value + ':' + selectedPlan();
    if (selection === observedSelection) return;
    observedSelection = selection;
    update(false);
  }).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'checked', 'aria-checked'] });
  update(false);
})();
